<template>
    <f7-page class="page-password">
        <f7-navbar :sliding="false">
          <f7-nav-left back-link="Trở lại"></f7-nav-left>
            <f7-nav-title sliding>ĐỔI MẬT KHẨU</f7-nav-title>
        </f7-navbar>
        <f7-list inset>
            <f7-list-input
                type="password"
                placeholder="Mật khẩu cũ"
                :value="form_password.old_password"
                @input="form_password.old_password = $event.target.value"
            >
                <f7-icon slot="media" ios="f7:person"></f7-icon>
            </f7-list-input>
            <f7-list-input
                placeholder="Mật khẩu mới"
                type="password"
                pattern="[0-9]{8}"
                inputmode="numeric"
                maxlength="8"
                info="Mật khẩu gồm 8 số"
                :value="form_password.new_password"
                @input="form_password.new_password = $event.target.value"
            >
                <f7-icon slot="media" ios="f7:lock"></f7-icon>
            </f7-list-input>
            <f7-list-input
                placeholder="Nhập lại MK mới"
                type="password"
                pattern="[0-9]{8}"
                inputmode="numeric"
                maxlength="8"
                :value="form_password.new_password_confirmation"
                @input="form_password.new_password_confirmation = $event.target.value"
            >
                <f7-icon slot="media" ios="f7:lock"></f7-icon>
            </f7-list-input>
        </f7-list>
        <f7-block inset class="mt-1">
            <f7-button fill color="primary" @click.prevent="submitChangePassword">ĐỔI MẬT KHẨU</f7-button>
        </f7-block>
    </f7-page>
</template>
<script>

export default {
    data(){
        return {
            form_password:{
                old_password             :'',
                new_password             :'',
                new_password_confirmation:''
            }
        }
    },
    methods   :{
        submitChangePassword(){
            this.$f7.dialog.preloader();

            this.$store.dispatch('changePassword', this.form_password).then(() => {
                this.$f7.dialog.close();
                this.$f7.dialog.alert('Đổi mật khẩu thành công', 'SUCCESS!');
                this.$store.dispatch('logout');
                this.$f7.views.main.router.navigate('/dang-nhap');
            }).catch((err) => {
                this.$f7.dialog.close();
                this.$f7.dialog.alert(err, 'LỖI!');
            });
        }
    }
};
</script>
